var _rect, _path;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWebchat = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#FF7661"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3H5.5C4.12 3 3 4.11556 3 5.49125V8.48274V8.98299C3 10.3587 4.12 11.4742 5.5 11.4742H6.25C6.385 11.4742 6.565 11.5643 6.65 11.6743L7.4 12.6698C7.73 13.1101 8.27 13.1101 8.6 12.6698L9.35 11.6743C9.445 11.5493 9.595 11.4742 9.75 11.4742H10.5C11.88 11.4742 13 10.3587 13 8.98299V5.49125C13 4.11556 11.88 3 10.5 3ZM6 8.0025C5.72 8.0025 5.5 7.77739 5.5 7.50225C5.5 7.22711 5.725 7.002 6 7.002C6.275 7.002 6.5 7.22711 6.5 7.50225C6.5 7.77739 6.28 8.0025 6 8.0025ZM8 8.0025C7.72 8.0025 7.5 7.77739 7.5 7.50225C7.5 7.22711 7.725 7.002 8 7.002C8.275 7.002 8.5 7.22711 8.5 7.50225C8.5 7.77739 8.28 8.0025 8 8.0025ZM10 8.0025C9.72 8.0025 9.5 7.77739 9.5 7.50225C9.5 7.22711 9.725 7.002 10 7.002C10.275 7.002 10.5 7.22711 10.5 7.50225C10.5 7.77739 10.28 8.0025 10 8.0025Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWebchat, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/webchat.26d4dad9.svg";
export { ForwardRef as ReactComponent };